import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

// OCR symbol: scan corner brackets around a document page with "OCR" text.
// A regular MUI SvgIcon (currentColor, accepts sx/fontSize), so it drops in
// anywhere an @mui/icons-material icon is used. Renders at 28px (overriding
// the toolbar's default 20px icon size) with a slightly cropped viewBox so
// the symbol fills more of its 36px button; the button itself is unchanged.
const OcrScanIcon = ({ sx, ...props }) => (
  <SvgIcon viewBox="1 1 22 22" {...props} sx={{ ...sx, fontSize: 28 }}>
    {/* scan corner brackets */}
    <path
      d="M2 7V3.5C2 2.67 2.67 2 3.5 2H7M17 2h3.5c.83 0 1.5.67 1.5 1.5V7M22 17v3.5c0 .83-.67 1.5-1.5 1.5H17M7 22H3.5C2.67 22 2 21.33 2 20.5V17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    {/* document page with folded corner */}
    <path
      d="M8.5 4.8h5.2l2.3 2.3v5.4H8.5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    {/* text lines on the page */}
    <path d="M10 8.2h3M10 10.2h4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    {/* "OCR" label */}
    <text
      x="12"
      y="19.4"
      textAnchor="middle"
      fontSize="6.2"
      fontWeight="800"
      fontFamily="Arial, Helvetica, sans-serif"
      letterSpacing="0.2"
      fill="currentColor"
    >
      OCR
    </text>
  </SvgIcon>
);

export default OcrScanIcon;
